import Api from '../http.service';

/**
   * get all passangers list
   * @param {Object} payload
   * @param {Number} payload.pageNumber
   * @param {Number} payload.itemPerPage
   * @param {Object} payload.data
   * @param {String} payload.data.flightDate
   * @param {String} payload.data.phrase
   * @param {String} payload.data.type

   */
export const fetchPreviousPassengersList = (payload) =>
  Api.POST({
    url: `passenger/previous_passengers/${payload.pageNumber - 1}/${
      payload.itemPerPage
    }`,
    data: payload.data,
  });

/**
 * create passenger
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.firstName
 * @param {String} payload.data.lastName
 * @param {String} payload.data.birthDate
 * @param {String} payload.data.passportExpireDate
 * @param {String} payload.data.passportNo
 * @param {String} payload.data.nationalCode
 * @param {String} payload.data.nationality
 * @param {String} payload.data.type
 * @param {String} payload.data.passportCountry
 * @param {String} payload.data.isMale
 * @param {String} payload.data.avatar
 */
export const insert = (payload) =>
  Api.POST({
    url: 'passenger',
    data: payload.data,
  });

/**
 * update passenger
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.firstName
 * @param {String} payload.data.lastName
 * @param {String} payload.data.birthDate
 * @param {String} payload.data.passportExpireDate
 * @param {String} payload.data.passportNo
 * @param {String} payload.data.nationalCode
 * @param {String} payload.data.nationality
 * @param {String} payload.data.type
 * @param {String} payload.data.passportCountry
 * @param {String} payload.data.isMale
 * @param {String} payload.data.avatar
 * @param {String} payload.data.id
 *
 */
export const update = (payload) =>
  Api.PUT({
    url: 'passenger',
    data: payload.data,
  });

/**
 * remopve passenger
 * @param {Object} payload
 * @param {String} payload._id
 */
export const remove = (payload) =>
  Api.DELETE({
    url: 'passenger',
    data: payload,
  });
